module.exports = __webpack_public_path__ + "static/ss8.7722fd89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/laminardata/ss/ss8.png
// module id = 1171
// module chunks = 112875127094159